export default "__VITE_ASSET__CMN_y0TC__"